import { defineMessages } from 'react-intl';

export default defineMessages({
    title: {
        id: 'app.recoverPassword.title',
        defaultMessage: 'Reset password'
    },
    description: {
        id: 'app.recoverPassword.description',
        defaultMessage: 'Enter your email below and we will send an email with a link where you can reset your password.'
    },
    successMessage: {
        id: 'app.recoverPassword.successMessage',
        defaultMessage: 'A recovery link has ben sent to your email.'
    },
    didSendSignupInstead: {
        id: 'app.recoverPassword.didSendSignupInstead',
        defaultMessage: 'A signup email have been sent to your email since you have not yet completed the signup for you account.'
    },
    placeholderEmail: {
        id: 'app.recoverPassword.placeholderEmail',
        defaultMessage: 'Email'
    },
    placeholderSubmit: {
        id: 'app.recoverPassword.placeholderSubmit',
        defaultMessage: 'Submit'
    }
});

export const errorMessages = defineMessages({
    SERVER_ERROR: {
        id: 'app.recoverPassword.errorServer',
        defaultMessage: 'Something went wrong'
    },
    FAILED_TO_SEND_EMAIL: {
        id: 'app.recoverPassword.errorInvalid',
        defaultMessage: 'Error sending mail, looks like an invalid email'
    },
    NON_EXISTING_EMAIL: {
        id: 'app.recoverPassword.errorNotFound',
        defaultMessage: 'No user was found with this email'
    }
});
